var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "supergroup-list container-fluid" },
    [
      _c("div", { staticClass: "row mb-4" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center"
            },
            [
              _c("h2", { staticClass: "h3" }, [_vm._v("Supergroups")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { disabled: !_vm.canManageSupergroups },
                  on: {
                    click: function($event) {
                      _vm.showCreateModal = true
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-plus-circle me-1" }),
                  _vm._v(" Create Supergroup\n        ")
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "row" }, [_vm._m(0)])
        : _vm.error
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "div",
                { staticClass: "alert alert-danger", attrs: { role: "alert" } },
                [
                  _c("i", { staticClass: "fa fa-exclamation-triangle me-2" }),
                  _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")
                ]
              )
            ])
          ])
        : !_vm.rootSupergroups.length
        ? _c("div", { staticClass: "row" }, [_vm._m(1)])
        : _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                class: {
                  "col-md-6": _vm.isUserPanelOpen,
                  "col-md-12": !_vm.isUserPanelOpen
                }
              },
              [
                _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    _vm._l(_vm.rootSupergroups, function(supergroup, index) {
                      return _c("SupergroupListItem", {
                        key: supergroup.uuid,
                        ref: "supergroupListItems",
                        refInFor: true,
                        attrs: {
                          itemClass: index % 2 === 1 ? "odd" : "even",
                          supergroup: supergroup,
                          "all-supergroups": _vm.supergroups,
                          canManageSupergroups: _vm.canManageSupergroups
                        },
                        on: {
                          edit: _vm.editSupergroup,
                          delete: _vm.confirmDelete,
                          select: _vm.selectSupergroup
                        }
                      })
                    }),
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm.isUserPanelOpen && _vm.selectedSupergroup
              ? _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _c("supergroup-users", {
                      attrs: { supergroup: _vm.selectedSupergroup },
                      on: { close: _vm.closeUserPanel }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
      _vm._v(" "),
      (_vm.showCreateModal || _vm.showEditModal) && _vm.canManageSupergroups
        ? _c("SupergroupForm", {
            attrs: {
              selectedSupergroup: _vm.currentSupergroup,
              allSupergroups: _vm.supergroups,
              "is-edit": _vm.showEditModal
            },
            on: { close: _vm.closeModal, save: _vm.saveSupergroup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showDeleteModal
        ? _c("div", { staticClass: "modal-backdrop" }, [
            _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: {
                        click: function($event) {
                          _vm.showDeleteModal = false
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-times" })]
                  ),
                  _vm._v(" "),
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Confirm Delete")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("p", [
                    _vm._v(
                      'Are you sure you want to delete the supergroup "' +
                        _vm._s(_vm.currentSupergroup.name) +
                        '"?'
                    )
                  ]),
                  _vm._v(" "),
                  _vm.hasChildren
                    ? _c("div", { staticClass: "alert alert-warning mt-3" }, [
                        _c("i", {
                          staticClass: "fa fa-exclamation-triangle me-2"
                        }),
                        _vm._v(
                          "\n            Warning: This supergroup has child supergroups that will also be deleted.\n          "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      on: {
                        click: function($event) {
                          _vm.showDeleteModal = false
                        }
                      }
                    },
                    [_vm._v("\n            Cancel\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      on: { click: _vm.deleteSupergroup }
                    },
                    [_vm._v("\n            Delete\n          ")]
                  )
                ])
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col text-center py-5" }, [
      _c("div", { staticClass: "spinner-border text-primary" }, [
        _c("span", { staticClass: "visually-hidden" }, [_vm._v("Loading...")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mt-3" }, [_vm._v("Loading supergroups...")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body text-center py-5" }, [
          _c("i", { staticClass: "fa fa-folder display-4 text-muted mb-3" }),
          _vm._v(" "),
          _c("p", { staticClass: "text-muted" }, [
            _vm._v(
              "\n            No supergroups found. Create your first supergroup to get started.\n          "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }